import { render, staticRenderFns } from "./type_2.vue?vue&type=template&id=150c0610&scoped=true"
import script from "./type_2.vue?vue&type=script&lang=js"
export * from "./type_2.vue?vue&type=script&lang=js"
import style0 from "./type_2.vue?vue&type=style&index=0&id=150c0610&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150c0610",
  null
  
)

export default component.exports